
const digest = '5a4f11f5ffd4f3aa98ccac269ee4f61a64ed4b0f04f7d4e02aabfba31d01247a';
const classes = {"item":"_item_3ikg1_1","patient":"_patient_3ikg1_9","patientImageContainer":"_patientImageContainer_3ikg1_17","patientImage":"_patientImage_3ikg1_17","badge":"_badge_3ikg1_30","red":"_red_3ikg1_39","patientData":"_patientData_3ikg1_42","title":"_title_3ikg1_47","date":"_date_3ikg1_53","text":"_text_3ikg1_57","mt20":"_mt-20_3ikg1_64","content":"_content_3ikg1_67","note":"_note_3ikg1_74","noteButton":"_noteButton_3ikg1_79","caseForwarder":"_caseForwarder_3ikg1_88","contentItem":"_contentItem_3ikg1_91","lightGrey":"_lightGrey_3ikg1_97","controls":"_controls_3ikg1_102","noMedicalReport":"_noMedicalReport_3ikg1_112","status":"_status_3ikg1_117","statusText":"_statusText_3ikg1_123","medicalReports":"_medicalReports_3ikg1_127"};
const css = `._item_3ikg1_1 {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_3ikg1_1 ._patient_3ikg1_9 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  gap: 16px;
  min-width: 350px;
  max-width: 350px;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientImageContainer_3ikg1_17 {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  height: fit-content;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientImageContainer_3ikg1_17 ._patientImage_3ikg1_17 {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  object-fit: cover;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientImageContainer_3ikg1_17 ._badge_3ikg1_30 {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  padding: 2px 5px;
  border-radius: 4px;
  bottom: -10px;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientImageContainer_3ikg1_17 ._red_3ikg1_39 {
  background-color: #f12848;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientData_3ikg1_42 {
  display: flex;
  gap: 3px;
  flex-direction: column;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientData_3ikg1_42 ._title_3ikg1_47 {
  font-size: 16px;
  font-weight: 500;
  margin-top: 8px;
  color: #000000;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientData_3ikg1_42 ._date_3ikg1_53 {
  color: #3e3f42;
  font-size: 12px;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientData_3ikg1_42 ._text_3ikg1_57 {
  color: #3e3f42;
  font-size: 14px;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientData_3ikg1_42 ._text_3ikg1_57 span {
  color: #9ea0a5;
}
._item_3ikg1_1 ._patient_3ikg1_9 ._patientData_3ikg1_42 ._mt-20_3ikg1_64 {
  margin-top: 20px;
}
._item_3ikg1_1 ._content_3ikg1_67 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 2px;
}
._item_3ikg1_1 ._content_3ikg1_67 ._note_3ikg1_74 {
  font-size: 14px;
  color: #3e3f42;
  font-weight: 400;
}
._item_3ikg1_1 ._content_3ikg1_67 ._noteButton_3ikg1_79 {
  font-weight: 400;
}
._item_3ikg1_1 ._content_3ikg1_67 ._title_3ikg1_47 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 12px;
}
._item_3ikg1_1 ._content_3ikg1_67 ._caseForwarder_3ikg1_88 {
  max-width: 490px;
}
._item_3ikg1_1 ._content_3ikg1_67 ._contentItem_3ikg1_91 {
  font-size: 14px;
  color: #000000;
  display: flex;
  gap: 5px;
}
._item_3ikg1_1 ._content_3ikg1_67 ._contentItem_3ikg1_91 ._lightGrey_3ikg1_97 {
  color: #9ea0a5;
  font-weight: 400;
  min-width: 140px;
}
._item_3ikg1_1 ._controls_3ikg1_102 {
  min-width: 300px;
  max-width: 300px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 24px 24px;
  gap: 24px;
}
._item_3ikg1_1 ._controls_3ikg1_102 ._noMedicalReport_3ikg1_112 {
  color: #787878;
  font-weight: 500;
  font-size: 14px;
}
._item_3ikg1_1 ._controls_3ikg1_102 ._status_3ikg1_117 {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
}
._item_3ikg1_1 ._controls_3ikg1_102 ._status_3ikg1_117 ._statusText_3ikg1_123 {
  font-size: 14px;
  font-weight: 500;
}
._item_3ikg1_1 ._controls_3ikg1_102 ._medicalReports_3ikg1_127 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  